
import { Component, Watch, Vue } from "vue-property-decorator";
import { mdiBell, mdiCircle } from "@mdi/js";
import { Getter } from "vuex-class";
import SvgIcon from "@jamescoyle/vue-icon";
import { clearCache } from "@/store/modules/storeCache";

@Component({
    components: {
        SvgIcon,
    },
})
export default class HeaderNotifications extends Vue {

  @Getter("notifications/headerNotifications") private headerNotifications: any;
  @Getter("notifications/unreadCount") private unreadCount: number;
  @Getter private isMobile: boolean;

  // Icons
  private mdiBell: any = mdiBell;
  private mdiCircle: any = mdiCircle;

  private openNotification: boolean = false;


  public goToNotificationsPage() {
    this.$router.push({ name: "notifications" });
    this.openNotification = false;
  }

  get hasMoreNotifications(): boolean {
  return this.unreadCount > this.headerNotifications.length;
  }

  get remainingNotifications(): number {
    return this.unreadCount - this.headerNotifications.length;
  }

  private handleNotificationClick(e: Event) {
    if (!this.headerNotifications.length || this.isMobile) {
      e.stopPropagation();
      e.preventDefault();

      this.goToNotificationsPage();
      return;
    }
    this.openNotification = true;
  }

  private async markAsRead(item) {
    try {
      await this.$store.dispatch("notifications/markAsRead", item.id);
      this.$store.commit("notifications/SET_HEADER_NOTIFICATIONS", this.headerNotifications.filter(
        (n) => n.id !== item.id,
      ));
      this.$store.commit("notifications/SET_UNREAD_COUNT", this.unreadCount - 1);
      await this.$store.dispatch("notifications/refetchNotifications");
    } catch (error) {
      this.$store.commit("alerts/displayHttpError", { error });
    }
  }
}
